
















































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import BusquedaDenuncias from './BusquedaDenuncias.vue'
import { denunciaStore, notificacionesStore, uiStore } from '@/store'
import FiltroDenuncias from '@/model/filtros/FiltroDenuncias'
import FormDenuncias from './FormDenuncias.vue'
import ShowDenuncias from './ShowDenuncias.vue'
import ShowActivacion from './ShowActivacion.vue'
import ShowBaja from './ShowBaja.vue'
import { OptionalId } from '@pjn/core/model/helpers/Types'
import { delay } from '@pjn/utils/delay'
import Denuncia from '@/model/Denuncia'
import { KEYS_ESTADO_DENUNCIA } from '@/api/StaticApi'
import { getDateStingFromDate } from '@/utils/DateUtil'
import { mapErrorToString } from '@/api/utils/Mappers'
function mapTo(item: any): Denuncia {
  let denuncia = {
    id: item.id,
    expediente: item.expediente,
    magistrado: item.magistrado,
    estado: item.estado,
    altaFecha: item.altaFecha,
    juzgado: item.juzgado,
    supuestos: item.supuestos,
    motivoBaja: item.motivoBaja,
    comision: item.comision
  } as any

  denuncia = item.estadoTramite
    ? { ...denuncia, estadoTramite: item.estadoTramite }
    : { ...denuncia, estadoTramite: '' }
  denuncia = item.aperturaResolucion
    ? { ...denuncia, aperturaResolucion: item.aperturaResolucion }
    : {
        ...denuncia,
        aperturaResolucion: {
          numero: (undefined as unknown) as number,
          anio: (undefined as unknown) as number
        }
      }
  denuncia = item.destitucionResolucion
    ? { ...denuncia, destitucionResolucion: item.destitucionResolucion }
    : {
        ...denuncia,
        destitucionResolucion: {
          numero: (undefined as unknown) as number,
          anio: (undefined as unknown) as number
        }
      }
  denuncia = item.sancionResolucion
    ? { ...denuncia, sancionResolucion: item.sancionResolucion }
    : {
        ...denuncia,
        sancionResolucion: {
          numero: (undefined as unknown) as number,
          anio: (undefined as unknown) as number
        }
      }

  return denuncia
}
@Component({
  components: {
    BusquedaDenuncias,
    FormDenuncias,
    ShowDenuncias,
    ShowActivacion,
    ShowBaja
  }
})
export default class CargaDenuncias extends Vue {
  mounted() {
    this.filtro = this.createNewFiltroInstance(this.tipo)
    this.buscar()
  }
  $refs: {
    busqueda: Vue & { buscar(): void; generarReporte(): void }
    form: Vue & {
      onClose(): void
      openDialog(estado: KEYS_ESTADO_DENUNCIA | undefined): void
      reset(): void
      resetValidation(): void
    }
    show: Vue & {
      onClose(): void
      openDialog(estado: KEYS_ESTADO_DENUNCIA | undefined): void
      reset(): void
      resetValidation(): void
    }
    activacion: Vue & { openDialog(): void }
    baja: Vue & { openDialog(): void }
  }

  @Prop({ type: Boolean, default: false })
  private disabled: boolean

  @Prop({ type: String })
  private tipo: string

  private filtro: FiltroDenuncias = new FiltroDenuncias()

  private loading = false

  private id = 0

  private formDisabled = false

  private showListado = true

  private error = false

  private errorMessage = ''

  private denuncia: OptionalId<Denuncia> = this.createNewInstance()

  createNewFiltroInstance(tipo?: string): FiltroDenuncias {
    const filtro = new FiltroDenuncias()
    if (tipo === 'porVencer' || tipo === 'vencidas') {
      filtro.estado = 'ACTIVA'
      const hasta = new Date(notificacionesStore.alerta?.hoy || '')
      const aniosAntiguedad =
        notificacionesStore.alerta?.configuracion.vigenciaAnios || 3
      hasta.setUTCFullYear(hasta.getUTCFullYear() - aniosAntiguedad)
      const desde = new Date(hasta.getTime())
      if (tipo === 'porVencer') {
        const diasMas = notificacionesStore.alerta
          ? notificacionesStore.alerta?.configuracion.proximas.dias
          : 1
        desde.setDate(hasta.getDate() + diasMas)
        filtro.fechaDesde = getDateStingFromDate(hasta)
        filtro.fechaHasta = getDateStingFromDate(desde)
      } else {
        hasta.setDate(hasta.getDate() - 1)
        filtro.fechaHasta = getDateStingFromDate(hasta)
      }
    }
    return filtro
  }
  createNewInstance() {
    return {
      magistrado: {
        cuil: (undefined as unknown) as number,
        nombre: (undefined as unknown) as string,
        apellido: ''
      },
      expediente: {
        resolucion: {
          numero: (undefined as unknown) as number,
          anio: (undefined as unknown) as number
        }
      },
      sancionResolucion: {
        numero: (undefined as unknown) as number,
        anio: (undefined as unknown) as number
      },
      aperturaResolucion: {
        numero: (undefined as unknown) as number,
        anio: (undefined as unknown) as number
      },
      destitucionResolucion: {
        numero: (undefined as unknown) as number,
        anio: (undefined as unknown) as number
      },
      estado: 'PENDIENTE',
      supuestos: [] as any[]
    } as Denuncia
  }

  private newInstance(formDisabled = false) {
    this.formDisabled = formDisabled
    if (!formDisabled) this.$refs.form.reset()
    this.denuncia = this.createNewInstance()
    this.id = 0
  }

  async editItem(item: Denuncia) {
    await this.newInstance()
    this.$nextTick(() => this.openItem(item))
  }
  private generarReporte() {
    this.$refs.busqueda.generarReporte()
  }
  async viewItem(item: Denuncia) {
    await this.newInstance(true)
    this.openItem(item, true)
  }
  async modifyState(item: Denuncia, estado?: KEYS_ESTADO_DENUNCIA) {
    await this.newInstance(true)
    this.openItem(item, true, estado)
  }
  showMessage(tipo: string) {
    tipo === 'activar'
      ? this.$refs.activacion.openDialog()
      : this.$refs.baja.openDialog()
  }

  openItem(item: Denuncia, disabled = false, estado?: KEYS_ESTADO_DENUNCIA) {
    if (!disabled) this.$refs.form.resetValidation()
    this.denuncia = this.createNewInstance()
    this.denuncia = mapTo(item)
    this.formDisabled
      ? this.$nextTick(() => this.$refs.show.openDialog(estado))
      : this.$nextTick(() => this.$refs.form.openDialog(estado))
  }
  async deleteItem(item: Denuncia) {
    try {
      this.loading = true
      await denunciaStore.delete(item.id)
      await this.newInstance()
      this.buscar()
    } catch (error) {
      this.showError(error.message || error)
      if (!item) {
        uiStore.notification.error(error)
      }
    } finally {
      this.loading = false
    }
  }
  buscar() {
    this.$refs.busqueda.buscar()
  }
  async showError(error) {
    this.error = true
    this.errorMessage = mapErrorToString(error)
    await delay(3000)
    this.error = false
  }
  saveActivation() {
    this.denuncia.estado = 'ACTIVA'
    this.saveItem(this.denuncia)
  }
  saveBaja(motivo: string) {
    this.denuncia.estado = 'BAJA'
    this.denuncia.motivoBaja = motivo
    this.saveItem(this.denuncia)
  }
  async saveItem(item: OptionalId<Denuncia>) {
    try {
      this.loading = true
      await denunciaStore.save(item)
      this.buscar()
      this.$refs.form.onClose()
    } catch (error) {
      this.showError(error)
      if (!item) {
        uiStore.notification.error(error)
      }
    } finally {
      this.loading = false
    }
  }

  limpiarFiltro() {
    this.filtro = this.createNewFiltroInstance()
  }
  @Watch('tipo')
  updateFiltro() {
    this.applyFilter(this.tipo)
  }

  async applyFilter(tipo: string) {
    this.limpiarFiltro()
    this.filtro = this.createNewFiltroInstance(tipo)
    this.$nextTick(function () {
      this.buscar()
    })
  }
}
